import React, { useState } from 'react';
import { Alert, Card, Button, Container, Row, Col } from 'react-bootstrap';
import './UpgradeMembershipComponent.css';

const UpgradeMembershipComponent = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const membershipPlans = [
    {
      id: 1,
      name: 'Premium',
      price: 'FREE',
      originalPrice: '$9.99',
      duration: 'Limited Time',
      features: [
        'Contact anyone',
        'Hide profile from free members',
        'Block emails from free members',
        'See who viewed your profile',
        'Advanced matching'
      ]
    },
    {
      id: 2,
      name: 'Gold',
      price: 'FREE',
      originalPrice: '$19.99',
      duration: 'Limited Time',
      features: [
        'All Premium features',
        'Featured profile placement',
        'Priority customer support',
        'Message read receipts',
        'Advanced search filters'
      ]
    },
    {
      id: 3,
      name: 'Platinum',
      price: 'FREE',
      originalPrice: '$29.99',
      duration: 'Limited Time',
      features: [
        'All Gold features',
        'Incognito browsing',
        'Profile boost every week',
        'See who likes your profile',
        'Video chat'
      ]
    }
  ];

  const handleSelectPlan = (planId) => {
    setSelectedPlan(planId);
  };

  const handleUpgrade = () => {
    if (!selectedPlan) {
      setErrorMessage('Please select a plan preview before proceeding.');
      setTimeout(() => setErrorMessage(''), 3000);
      return;
    }

    // This would be replaced with actual API call in production
    setTimeout(() => {
      setSuccessMessage('Success! You now have free access to premium features. Enjoy all benefits at no cost during our promotional period.');
      setTimeout(() => setSuccessMessage(''), 5000);
    }, 1000);
  };

  return (
    <div className="upgrade-membership-container">
      {successMessage && (
        <Alert 
          variant="success" 
          className="settings-alert success-alert"
          dismissible
          onClose={() => setSuccessMessage('')}
        >
          <Alert.Heading>Success!</Alert.Heading>
          <p>{successMessage}</p>
        </Alert>
      )}
      
      {errorMessage && (
        <Alert 
          variant="danger" 
          className="settings-alert error-alert"
          dismissible
          onClose={() => setErrorMessage('')}
        >
          <Alert.Heading>Error</Alert.Heading>
          <p>{errorMessage}</p>
        </Alert>
      )}

      <div className="settings-panel">
        <div className="settings-header">Upgrade Your Membership</div>
        
        <div className="settings-content">
          <div className="free-announcement">
            <h3>Special Announcement</h3>
            <p>All premium features are currently <span className="free-highlight">FREE</span> for a limited time!</p>
            <p>Enjoy premium benefits while we're in beta. Regular pricing will begin soon, so take advantage of all features now.</p>
          </div>
          
          <p className="upgrade-intro">
            Preview our upcoming premium plans - no payment required during this promotional period.
          </p>
          
          <div className="membership-plans">
            {membershipPlans.map(plan => (
              <Card 
                key={plan.id}
                className={`plan-card ${selectedPlan === plan.id ? 'selected' : ''}`}
                onClick={() => handleSelectPlan(plan.id)}
              >
                <Card.Body>
                  <div className="plan-title">{plan.name}</div>
                  <div className="plan-price">{plan.price}</div>
                  <div className="plan-original-price"><s>{plan.originalPrice}</s></div>
                  <div className="plan-duration">{plan.duration}</div>
                  <ul className="plan-features">
                    {plan.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                  <Button 
                    variant={selectedPlan === plan.id ? "success" : "outline-success"}
                    className="select-plan-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelectPlan(plan.id);
                    }}
                  >
                    {selectedPlan === plan.id ? "Selected" : "Select Preview"}
                  </Button>
                </Card.Body>
              </Card>
            ))}
          </div>
        </div>
        
        <div className="upgrade-action">
          <Button 
            variant="primary" 
            size="lg"
            onClick={handleUpgrade}
            disabled={!selectedPlan}
          >
            Activate Free Access
          </Button>
          <p className="no-payment-note">No payment information required</p>
        </div>
      </div>
    </div>
  );
};

export default UpgradeMembershipComponent;